import { Container } from 'statuo';

import { pickBy, merge } from 'lodash';

import getResults from '../../../03-api/filtering/filter';

import addEndpointResponseTransform from '../transforms/add-endpoint-response';

/* ========================================================================== */

const initialState = pickBy(
		merge(
			{},
			{
				NodeId: "",
				Page: 1,
				Filters: []				
			}
		),
		// We do this as a trick, to make sure we don't keep ahold of
		// a possible coursenumber and/or loopnumber from a course detail page.
		(value) => value !== null
	),
	responseKey = 'response',
	addEndpointResponseTransformConfig = {
		endpoint: getResults,
		omitKeys: [responseKey],
		stateKey: responseKey
	};

/* ========================================================================== */

export default class extends Container {
	constructor() {
		super({
			state: initialState,
			transforms: [
				addEndpointResponseTransform(addEndpointResponseTransformConfig)
			]
		});
	}
}
